import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { SalesTracker } from "@/components/tools/SalesTracker";
import { FbaStocks } from "@/components/tools/FbaStocks";
import { InventoryPlanner } from "@/components/tools/InventoryPlanner";
import { Reviews } from "@/components/tools/Reviews";
import { Recommendations } from "@/components/tools/Recommendations";
import { Pnl } from "@/components/tools/Pnl";
import { ListingQuality } from "@/components/tools/ListingQuality";
import { SettlementSku } from "@/components/tools/SettlementSku";
import { Reconciliation } from "@/components/tools/Reconciliation";
import { AmazonDashboard } from "@/components/tools/AmazonDashboard";
import { PriceTracker } from "@/components/tools/PriceTracker";
import { AdInvoices } from "@/components/tools/AdInvoices";
import { StockAlerts } from "@/components/tools/StockAlerts";
import { ShipmentsPipeline } from "@/components/tools/ShipmentsPipeline";
import { ReturnsAnalysis } from "@/components/tools/ReturnsAnalysis";
import { InventoryRemoval } from "@/components/tools/InventoryRemoval";
import { ListingIssues } from "@/components/tools/ListingIssues";
import { ReimbursementRecovery } from "@/components/tools/ReimbursementRecovery";

const TABS = [
  { value: "dashboard", label: "Dashboard", testId: "tab-dashboard", perm: "amz_dashboard", El: AmazonDashboard },
  { value: "stock-alerts", label: "Stock Alerts", testId: "tab-stock-alerts", perm: "stock_alerts", El: StockAlerts },
  { value: "shipments", label: "Shipments", testId: "tab-shipments", perm: "shipments", El: ShipmentsPipeline },
  { value: "returns", label: "Returns Analysis", testId: "tab-returns-analysis", perm: "returns_analysis", El: ReturnsAnalysis },
  { value: "listing-issues", label: "Listing Issues", testId: "tab-listing-issues", perm: "listing_issues", El: ListingIssues },
  { value: "recovery", label: "Reimbursement Recovery", testId: "tab-reimb-recovery", perm: "reimb_recovery", El: ReimbursementRecovery },
  { value: "tracker", label: "Sales Tracker", testId: "tab-sales-tracker", perm: "sales_tracker", El: SalesTracker },
  { value: "price-tracker", label: "Price Tracker", testId: "tab-price-tracker", perm: "price_tracker", El: PriceTracker },
  { value: "fba", label: "FBA Stocks", testId: "tab-fba-stocks", perm: "fba", El: FbaStocks },
  { value: "planner", label: "Inventory Planner", testId: "tab-inventory-planner", perm: "planner", El: InventoryPlanner },
  { value: "removal", label: "Inventory Removal", testId: "tab-inventory-removal", perm: "inventory_removal", El: InventoryRemoval },
  { value: "reviews", label: "Review Automation", testId: "tab-reviews", perm: "reviews", El: Reviews },
  { value: "quality", label: "Listing Quality", testId: "tab-listing-quality", perm: "listing_quality", El: ListingQuality },
  { value: "recs", label: "AI Recommendations", testId: "tab-recommendations", perm: "recommendations", El: Recommendations },
  { value: "settlement-sku", label: "Settlement Analysis", testId: "tab-settlement-sku", perm: "settlement_analysis", El: SettlementSku },
  { value: "reco", label: "Reconciliation", testId: "tab-reconciliation", perm: "reconciliation", El: Reconciliation },
  { value: "pnl", label: "Monthly P&L", testId: "tab-pnl", perm: "pnl", El: Pnl },
  { value: "ad-invoices", label: "Ad Invoices", testId: "tab-ad-invoices", perm: "ad_invoices", El: AdInvoices },
];

export default function AmazonTools() {
  const { can } = useAuth();
  const visible = TABS.filter((t) => can(t.perm));
  if (visible.length === 0)
    return <p className="text-sm text-muted-foreground p-6" data-testid="tools-no-access">You don't have access to any Amazon tools — ask your admin.</p>;
  return (
    <div className="space-y-6" data-testid="amazon-tools-page">
      <Tabs defaultValue={visible[0].value}>
        <TabsList className="rounded-full h-auto p-1 flex-nowrap lg:flex-wrap justify-start max-w-full overflow-x-auto no-scrollbar">
          {visible.map((t) => (
            <TabsTrigger key={t.value} value={t.value} className="rounded-full px-4 shrink-0" data-testid={t.testId}>{t.label}</TabsTrigger>
          ))}
        </TabsList>
        {visible.map((t) => (
          <TabsContent key={t.value} value={t.value} className="mt-6 min-w-0 w-full max-w-full"><t.El /></TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
